import { c as l } from "../../../../index.esm-BeDSGXP5.js";
import { css as o } from "styled-components";
const t = (e) => e.componentColors.progressBar, p = {
  wrapper: () => /* @__PURE__ */ o([
    "text-align:center;"
  ]),
  bar: ({ theme: e }) => /* @__PURE__ */ o([
    "",
    " display:flex;flex-wrap:nowrap;width:100%;"
  ], e.resets.space),
  step: () => /* @__PURE__ */ o([
    "position:relative;list-style-type:none;text-align:center;"
  ]),
  sliderWrapper: ({ theme: e }) => /* @__PURE__ */ o([
    "position:relative;width:10rem;height:30px;box-sizing:border-box;margin-left:-12px;width:calc(100% + 24px);background-color:",
    ";border:1px solid ",
    ";border-radius:17px;"
  ], t(e).step.remaining, t(e).base.border),
  slider: ({ theme: e }) => /* @__PURE__ */ o([
    "height:28px;position:relative;left:0;z-index:2;background-color:",
    ";border-radius:17px;@media (forced-colors:active){outline:1px solid ",
    ";}"
  ], t(e).step.filled, t(e).step.filled),
  marker: ({ theme: e }) => /* @__PURE__ */ o([
    "position:absolute;top:2px;left:calc(100% - 26px);z-index:3;color:",
    ";"
  ], t(e).marker.icon),
  stepText: ({ theme: e, variant: r }) => /* @__PURE__ */ o([
    "",
    ""
  ], l({
    color: t(e).step[r].text,
    marginTop: "xs",
    width: "100%",
    display: [
      "none",
      null,
      "block"
    ]
  })),
  currentStepText: ({ theme: e, variant: r }) => /* @__PURE__ */ o([
    "",
    ""
  ], l({
    color: t(e).step[r].text,
    marginTop: "xs",
    display: [
      "block",
      null,
      "none"
    ]
  })),
  stepCount: ({ theme: e, variant: r }) => /* @__PURE__ */ o([
    "text-transform:uppercase;display:block;",
    ""
  ], l({
    color: t(e).step[r].text,
    fontFamily: "heading",
    fontWeight: [
      "semiBold",
      null,
      "bold"
    ],
    fontSize: [
      "textSmallMobile",
      null,
      "textMediumDesktop"
    ],
    marginTop: [
      "xs",
      null,
      "sm"
    ]
  }))
};
export {
  p as default
};
